import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UsePanel from "./UserPanel";
import OrderStatus from "./OrderStatus";
import Notifications from "./Notifications";
import SocialSource from "./SocialSource";
import OverView from "./OverView";
import RevenueByLocation from "./RevenueByLocation";
import LatestTransation from "./LatestTransation";
import GrowthChart from "./GrowthChart";
import RecentLeads from "./RecentLeads";
import RecentEvents from "./RecentEvents";
import LeadsDistribution from "./LeadsDistribution";
import NeedsFollowUp from "./NeedsFollowUp";
import { GetData } from "../../services/api";
import Loader from "../../components/Common/Loader";

import { Row, Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//Import Dashboard CSS
import "./dashboard.css";



const Dashboard = () => {
  document.title = "CRM Innova Hub Group";
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([])
  const [contactList, setContactList] = useState([])
  const [leadsStats, setLeadsStats] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const checkOnboarding = async () => {
      try {
        const response = await GetData('/users/onboarding-status').catch(err => {
          console.warn("Error checking onboarding status:", err);
          return { data: { completed: true } };
        });
        
        // Si no completó el onboarding, redirigir a la página de onboarding
        if (response?.data && !response.data.completed) {
          navigate('/onboarding');
          return;
        }
      } catch (error) {
        console.error('Error checking onboarding status:', error);
      }
    };
    
    checkOnboarding();
  }, [navigate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [customersRes, contactListsRes, leadsStatsRes] = await Promise.all([
          GetData(`/customers`),
          GetData(`/contact-lists`),
          GetData(`/dashboard/leads-stats`).catch(err => {
            console.warn("Error fetching leads stats:", err);
            return { data: null };
          })
        ]);
        
        setCustomers(customersRes.data || [])
        setContactList(contactListsRes.data || [])
        setLeadsStats(leadsStatsRes.data || null)
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content dashboard-container">
        {/* Loader de pantalla completa mientras carga */}
        {loading && (
          <Loader message="Cargando ..." fullScreen={true} size={200} />
        )}

        <Container fluid={true} style={{ paddingBottom: "2rem" }}>
          <Breadcrumbs title="IHG" breadcrumbItem="Dashboard" />
          
          {/* KPIs Principales */}
          <UsePanel leadsStats={leadsStats} />

          {/* Primera Fila: Gráfico de Crecimiento y Últimos Leads */}
          <Row className="mb-3">
            <GrowthChart leadsStats={leadsStats} />
            <RecentLeads leadsStats={leadsStats} />
          </Row>

          {/* Segunda Fila: Distribución y Eventos */}
          <Row className="mb-3">
            <LeadsDistribution leadsStats={leadsStats} />
            <RecentEvents leadsStats={leadsStats} />
          </Row>

          {/* Tercera Fila: Seguimiento */}
          <Row>
            <NeedsFollowUp leadsStats={leadsStats} />
          </Row>

          {/* <Row> */}
          {/* Order Stats */}
          {/* <OrderStatus /> */}
          {/* Notifications */}
          {/* <Notifications /> */}
          {/* Revenue by Location Vector Map */}
          {/* <RevenueByLocation /> */}
          {/* </Row> */}

          {/* Latest Transaction Table */}
          {/* <LatestTransation /> */}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
